import connectToStores from "alt-utils/lib/connectToStores";
import OrderStore from "../app/stores/OrderStore";
import AppStore from "../app/stores/AppStore";
import EventStore from "../app/stores/EventStore";
import PassStore from "../app/stores/PassStore";
import PersonStore from "../app/stores/PersonStore";
import ItemBucketStore from "../app/stores/ItemBucketStore";
import OrderActions from "../app/actions/OrderActions";
import EventActions from "../app/actions/EventActions";
import PassActions from "../app/actions/PassActions";
import CouponActions from "../app/actions/CouponActions";
import ItemBucketActions from "../app/actions/ItemBucketActions";

import BaseOverlay from "../app/components/overlays/base.jsx";
import Checkout from "../app/components/partials/checkout.jsx";
import { CircularProgress, RaisedButton } from "material-ui";

/**
 * Checkout Eventive Everywhere widget
 * onSuccess: (order) => void;
 * onCancel: () => void;
 * onError: (error) => void;
 */
class CheckoutWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subitemDetails: {},
      isReady: false
    };

    this.cancel = this.cancel.bind(this);
  }

  componentWillMount() {
    OrderActions.newOrderFlow();
    OrderActions.updateCurrentOrder({
      subitems: this.props.options.order.subitems || [],
      ...(this.props.options.include_itemized_summary
        ? {
            include_itemized_summary: true
          }
        : {})
    });
    CouponActions.reset();
  }

  componentWillReceiveProps(newProps) {
    if (
      this.props.orderInProgress &&
      newProps.orderSuccess &&
      !this.props.orderSuccess
    ) {
      const completedOrder = this.props.getOrderById(
        this.props.completedOrderId
      );
      this.props.onSuccess(completedOrder);
    }

    const subitems = this.props.options.order.subitems;
    const requiredEvents = subitems.filter(s => s.event).map(s => s.event);
    const requiredTicketBuckets = subitems
      .filter(s => s.ticket_bucket)
      .map(s => s.ticket_bucket);
    const requiredPassBuckets = subitems
      .filter(s => s.pass_bucket)
      .map(s => s.pass_bucket);
    const requiredItemBuckets = subitems
      .filter(s => s.item_bucket)
      .map(s => s.item_bucket);

    const requiredIds = [
      ...requiredEvents,
      ...requiredTicketBuckets,
      ...requiredPassBuckets,
      ...requiredItemBuckets
    ];
    if (JSON.stringify(requiredIds) !== this._lastFetchedIds) {
      this._lastFetchedIds = JSON.stringify(requiredIds);
      if (requiredEvents.length) {
        EventActions.fetchAll.defer({
          includePastEvents: true,
          eventIds: requiredEvents
        });
      }
      if (requiredTicketBuckets.length) {
        // Note: not officially supported. Must be specified by `event`.
        // We will try just fetching everything though...
        EventActions.fetchAll.defer({
          includePastEvents: true
        });
      }
      if (requiredPassBuckets.length) {
        PassActions.fetchPassTypes.defer({
          passBucketIds: requiredPassBuckets
        });
      }
      if (requiredItemBuckets.length) {
        ItemBucketActions.fetchAll({
          ids: requiredItemBuckets
        });
      }
    }

    let isReady = true;
    const subitemDetails = {};
    requiredEvents.forEach(eventId => {
      subitemDetails[eventId] =
        this.props.getDefaultTicketBucketWithEventByEventId(eventId);
      if (!subitemDetails[eventId]) isReady = false;
    });
    requiredTicketBuckets.forEach(ticketBucketId => {
      subitemDetails[ticketBucketId] =
        this.props.getTicketBucketWithEventById(ticketBucketId);
      if (!subitemDetails[ticketBucketId]) isReady = false;
    });
    requiredPassBuckets.forEach(passBucketId => {
      subitemDetails[passBucketId] = this.props.getPassTypeById(passBucketId);
      if (!subitemDetails[passBucketId]) isReady = false;
    });
    requiredItemBuckets.forEach(itemBucketId => {
      subitemDetails[itemBucketId] = this.props.getItemBucketById(itemBucketId);
      if (!subitemDetails[itemBucketId]) isReady = false;
    });
    this.setState({ subitemDetails, isReady });
  }

  static getStores() {
    return [
      AppStore,
      OrderStore,
      EventStore,
      PassStore,
      ItemBucketStore,
      PersonStore
    ];
  }

  static getPropsFromStores() {
    var state = OrderStore.getState();
    state.getOrderById = OrderStore.getOrderById;
    state.getEventById = EventStore.getEventById;
    state.getTicketBucketWithEventById =
      EventStore.getTicketBucketWithEventById;
    state.getDefaultTicketBucketWithEventByEventId =
      EventStore.getDefaultTicketBucketWithEventByEventId;
    state.getPassTypeById = PassStore.getPassTypeById;
    state.getItemBucketById = ItemBucketStore.getItemBucketById;
    state.isLoggedIn = PersonStore.getState().isLoggedIn;
    state.person = PersonStore.getState().details;
    return state;
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object
    };
  }

  cancel() {
    if (!(this.props.orderInProgress || this.props.orderSuccess)) {
      this.props.onCancel();
    }
  }

  render() {
    const { subitemDetails, isReady } = this.state;
    const isWorking = !isReady;

    if (isWorking) {
      return (
        <BaseOverlay onRequestClose={this.cancel}>
          <div>
            <CircularProgress
              mode="indeterminate"
              size={119}
              thickness={7}
              style={{ display: "block", margin: "10px auto 0" }}
            />
          </div>
        </BaseOverlay>
      );
    }

    let error = null;
    if (!this.props.isLoggedIn) {
      error = `You must be logged in prior to check out.`;
    }

    if (error) {
      return (
        <BaseOverlay onRequestClose={this.cancel}>
          <div style={{ padding: "2em" }}>
            <div
              style={{
                fontSize: "12pt",
                color: "red",
                textAlign: "center"
              }}
            >
              {error}
            </div>
            <div style={{ marginTop: "1.5em", textAlign: "center" }}>
              <RaisedButton
                label="Exit checkout"
                primary
                onClick={() => this.props.onCancel()}
              />
            </div>
          </div>
        </BaseOverlay>
      );
    }

    return (
      <BaseOverlay onRequestClose={this.cancel}>
        <Checkout
          orderInProgress={this.props.orderInProgress}
          orderSuccess={this.props.orderSuccess}
          orderErrorMessage={this.props.orderErrorMessage}
          orderData={this.props.orderData}
          updateCurrentOrder={data => {
            OrderActions.updateCurrentOrder(data);
          }}
          person={this.props.person}
          isLoggedIn={this.props.isLoggedIn}
          isCheckoutWidgetView={true}
          initialCouponCode={this.props.options.order.coupon}
          subitemDetails={subitemDetails}
          fixedQuantity={true}
          isWidgetView={true}
          cancel={() => this.props.onCancel()}
          submit={() => OrderActions.submitOrder.defer()}
        />
      </BaseOverlay>
    );
  }
}

export default connectToStores(CheckoutWidget);



// WEBPACK FOOTER //
// ./src/widget/checkout-widget.jsx